import React, { useMemo } from "react";
import { Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { getExpiryDays } from "../../../services/usersManagementService";
import { getExpiryAlertStyles } from "../helpers/getExpiryAlertStyles";

const AlertsView = ({ users, setActiveTab, onSelectUser }) => {
  const sorted = useMemo(
    () =>
      [...users].sort(
        (a, b) => getExpiryDays(a.expiryDate) - getExpiryDays(b.expiryDate)
      ),
    [users]
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h6" fontWeight={600}>
        Alertas de vencimiento
      </Typography>
      <Stack spacing={1.5}>
        {sorted.map((user) => {
          const { bg, border, color, indicator, days } =
            getExpiryAlertStyles(user);
          return (
            <Paper
              key={user.id}
              elevation={1}
              sx={{
                p: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: border,
                bgcolor: bg,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 6,
                    height: 40,
                    borderRadius: 3,
                    bgcolor: indicator,
                  }}
                />
                <Box>
                  <Typography
                    variant="subtitle2"
                    sx={{ color, fontWeight: 600 }}
                  >
                    {user.company}
                  </Typography>
                  <Typography variant="caption" sx={{ color, opacity: 0.8 }}>
                    {user.email}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                <Box sx={{ textAlign: "right" }}>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 700,
                      textTransform: "uppercase",
                      opacity: 0.7,
                    }}
                  >
                    Expira en
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 900, color }}
                  >
                    {days <= 0 ? "VENCIDO" : `${days} días`}
                  </Typography>
                </Box>
                <IconButton
                  size="small"
                  onClick={() => {
                    setActiveTab("users");
                    onSelectUser?.(user);
                  }}
                >
                  <ChevronRightIcon />
                </IconButton>
              </Box>
            </Paper>
          );
        })}
      </Stack>
    </Box>
  );
};

export default AlertsView;
